function hasDuration(interval, minDuration) {
  if (!minDuration)
    return interval.high > interval.low;
  else
    return interval.high - minDuration >= interval.low;
}
function* findGaps(intervals, concurrentAllowed, minDuration, startTime = 0) {
  if (intervals.length === 0)
    return [];
  if (minDuration != null && minDuration < 1)
    throw new Error("minDuration must be >= 1");
  const events = [];
  for (const interval of intervals) {
    events.push({ time: interval.low, type: "low" });
    events.push({ time: interval.high, type: "high" });
  }
  events.sort((a, b) => a.time - b.time || (a.type === "high" ? -1 : 1));
  let concurrency = 0;
  let prevTime = startTime;
  for (const event of events) {
    if (event.type === "low") {
      if (concurrency >= concurrentAllowed) {
        if (prevTime != null && prevTime < event.time) {
          const interval = { low: prevTime, high: event.time };
          if (hasDuration(interval, minDuration))
            yield interval;
          prevTime = null;
        } else if (prevTime === event.time) {
          prevTime = null;
        }
      }
      concurrency++;
    } else {
      concurrency--;
      if (concurrency <= concurrentAllowed && prevTime == null) {
        prevTime = event.time;
      }
    }
  }
  if (prevTime != null && concurrency <= concurrentAllowed && prevTime !== events[events.length - 1].time) {
    const low = prevTime;
    const high = events[events.length - 1].time;
    const interval = { low, high };
    if (hasDuration(interval, minDuration))
      yield interval;
  }
}
export {
  findGaps
};
